import { Box } from "@mui/material";
import { style } from "./table.style";
export const TableBody = ({ children }) => <Box component="tbody" sx={style.tableBody} className="table__body">{children}</Box>;
